function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function isServer() {
  return typeof window === 'undefined';
}
function isArray(value) {
  return ['[object Array]'].includes(Object.prototype.toString.call(value));
}
function isObject(value) {
  return ['[object Object]'].includes(Object.prototype.toString.call(value));
}
/**
 * 首字母转为大写
 * @param str 字符串
 */

function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

/**
 * 处理一下 code, 获取多语言单复数规则中的语系
 * @param code 多语言对应 code
 */

function formatLanguageCode(code) {
  // http://www.iana.org/assignments/language-tags/language-tags.xhtml
  if (code.indexOf('-') > -1) {
    var specialCases = ['hans', 'hant', 'latn', 'cyrl', 'cans', 'mong', 'arab'];
    var p = code.split('-');

    if (p.length === 2) {
      p[0] = p[0].toLowerCase();
      p[1] = p[1].toUpperCase();
      if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
    } else if (p.length === 3) {
      p[0] = p[0].toLowerCase(); // if length 2 guess it's a country

      if (p[1].length === 2) p[1] = p[1].toUpperCase();
      if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
      if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
      if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
    }

    return p.join('-');
  }

  return code;
}
/**
 * 获取多语言对应 code
 * @param code 多语言 locale
 */


function getLanguagePartFromCode(code) {
  var p = code.split('-');
  return formatLanguageCode(p[0]);
}

/**
 * 语系对应单复数规则
 * nr: 每种情况数量举例，fc: rulesPluralsTypes 对应 index
 */

var sets = [{
  lngs: ['ach', 'ak', 'am', 'arn', 'br', 'fil', 'gun', 'ln', 'mfe', 'mg', 'mi', 'oc', 'pt', 'pt-BR', 'tg', 'ti', 'tr', 'uz', 'wa'],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ['af', 'an', 'ast', 'az', 'bg', 'bn', 'ca', 'da', 'de', 'dev', 'el', 'en', 'eo', 'es', 'et', 'eu', 'fi', 'fo', 'fur', 'fy', 'gl', 'gu', 'ha', 'hi', 'hu', 'hy', 'ia', 'it', 'kn', 'ku', 'lb', 'mai', 'ml', 'mn', 'mr', 'nah', 'nap', 'nb', 'ne', 'nl', 'nn', 'no', 'nso', 'pa', 'pap', 'pms', 'ps', 'pt-PT', 'rm', 'sco', 'se', 'si', 'so', 'son', 'sq', 'sv', 'sw', 'ta', 'te', 'tk', 'ur', 'yo'],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ['ay', 'bo', 'cgg', 'fa', 'ht', 'id', 'ja', 'jbo', 'ka', 'kk', 'km', 'ko', 'ky', 'lo', 'ms', 'sah', 'su', 'th', 'tt', 'ug', 'vi', 'wo', 'zh'],
  nr: [1],
  fc: 3
}, {
  lngs: ['be', 'bs', 'cnr', 'dz', 'hr', 'sr', 'uk'],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ['ru'],
  fc: 23
}, {
  lngs: ['ar'],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ['cs', 'sk'],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ['csb', 'pl'],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ['cy'],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ['fr'],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ['ga'],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ['gd'],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ['is'],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ['jv'],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ['kw'],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ['lt'],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ['lv'],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ['mk'],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ['mnk'],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ['mt'],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ['or'],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ['ro'],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ['sl'],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ['he', 'iw'],
  nr: [1, 2, 20, 21],
  fc: 22
}];
/**
 * 用于获取单复数规则索引函数，传入一个数量, 确定为单复数多项规则中的第几项
 */
// prettier-ignore

var rulesPluralsTypes = {
  1: function _(n) {
    return Number(n > 1);
  },
  2: function _(n) {
    return Number(n !== 1);
  },
  3: function _() {
    return 0;
  },
  4: function _(n) {
    return Number(n % 10 === 1 && n % 100 !== 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  5: function _(n) {
    return Number(n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
  },
  6: function _(n) {
    return Number(n === 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
  },
  7: function _(n) {
    return Number(n === 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  8: function _(n) {
    return Number(n === 1 ? 0 : n === 2 ? 1 : n !== 8 && n !== 11 ? 2 : 3);
  },
  9: function _(n) {
    return Number(n >= 2);
  },
  10: function _(n) {
    return Number(n === 1 ? 0 : n === 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
  },
  11: function _(n) {
    return Number(n === 1 || n === 11 ? 0 : n === 2 || n === 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
  },
  12: function _(n) {
    return Number(n % 10 !== 1 || n % 100 === 11);
  },
  13: function _(n) {
    return Number(n !== 0);
  },
  14: function _(n) {
    return Number(n === 1 ? 0 : n === 2 ? 1 : n === 3 ? 2 : 3);
  },
  15: function _(n) {
    return Number(n % 10 === 1 && n % 100 !== 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  16: function _(n) {
    return Number(n % 10 === 1 && n % 100 !== 11 ? 0 : n !== 0 ? 1 : 2);
  },
  17: function _(n) {
    return Number(n === 1 || n % 10 === 1 && n % 100 !== 11 ? 0 : 1);
  },
  18: function _(n) {
    return Number(n === 0 ? 0 : n === 1 ? 1 : 2);
  },
  19: function _(n) {
    return Number(n === 1 ? 0 : n === 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
  },
  20: function _(n) {
    return Number(n === 1 ? 0 : n === 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
  },
  21: function _(n) {
    return Number(n % 100 === 1 ? 1 : n % 100 === 2 ? 2 : n % 100 === 3 || n % 100 === 4 ? 3 : 0);
  },
  22: function _(n) {
    return Number(n === 1 ? 0 : n === 2 ? 1 : (n < 0 || n > 10) && n % 10 === 0 ? 2 : 3);
  },
  23: function _(n) {
    if (typeof n === 'string') {
      // 含有小数点
      return 3;
    }

    return Number(n % 10 === 1 && n % 100 !== 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && !(n % 100 >= 12 && n % 100 <= 14) ? 1 : n % 10 === 0 || n % 10 >= 5 && n % 10 <= 9 || n % 100 >= 11 && n % 100 <= 14 ? 2 : 3);
  }
};
/**
 * 获取规则函数
 * @param locale 目标语言
 * @param n 数量
 * @return 获取单复数规则索引
 */

function getPluralsIndex(locale, n) {
  var lng = getLanguagePartFromCode(locale);
  var targetFunctionKey = 2;
  var formattedN = n;
  sets.some(function (set) {
    if (set.lngs.includes(lng)) {
      targetFunctionKey = set.fc;
      return true;
    }

    return false;
  }); //含有小数点用字符串表示，否则，用数字表示

  if (!n.includes('.')) {
    formattedN = Number(n);
  }

  return rulesPluralsTypes[targetFunctionKey](formattedN);
}

var I18n = /*#__PURE__*/function () {
  function I18n(options) {
    //默认配置项
    this.options = {
      isDebugMode: false,
      locale: 'en',
      messages: {
        en: {
          test: 'test'
        },
        'zh-CN': {
          test: '测试'
        }
      },
      interpolation: {
        prefix: '{',
        postfix: '}',
        linkKeyWord: 'MULTILANG_URL_PLACEHOLDER'
      }
    };
    this.tCache = {};
    this.options = Object.assign(this.options, options);
  }
  /**
   * 获取 text_id
   * @param key 多语言 key, '123041-product.details.inventory', //text id+语义化key，以 - 分隔
   */


  I18n.getTextId = function getTextId(key) {
    var id = key.split('-')[0];

    if (/^\d+$/.test(id)) {
      return id;
    }

    return key;
  }
  /**
   * 替换多语言中 link
   * @param content 多语言内容
   * @param data 多语言变量替换对象
   */
  ;

  var _proto = I18n.prototype;

  _proto.transformLinkKeyWord = function transformLinkKeyWord(content, data) {
    var keyWord = this.options.interpolation.linkKeyWord || 'MULTILANG_URL_PLACEHOLDER';
    return content.replace(keyWord, data[keyWord] || '');
  }
  /**
   * 获取多模版的目标多语言
   * @param localeStrObj 多语言 key 对应的对象
   * @param templateCategory 多模版用来命中模版的 category
   */
  ;

  _proto.getTemplateLocaleStr = function getTemplateLocaleStr(localeStrObj, templateCategory) {
    var locale = this.options.locale;
    var template_type = localeStrObj.template_type,
        content = localeStrObj.content;
    var templates = content.templates;
    var templateLocaleStr = '';

    switch (template_type) {
      case 'boolean':
      case 'enum':
        {
          var targetTemplate = templates.find(function (x) {
            return String(x.category) === String(templateCategory);
          }) || templates.find(function (x) {
            return x.isDefault;
          });

          if (targetTemplate) {
            templateLocaleStr = targetTemplate.content;
          }

          break;
        }

      case 'plural':
        {
          var targetIndex = getPluralsIndex(locale, String(templateCategory));

          var _targetTemplate = templates[targetIndex] || templates.find(function (x) {
            return x.isDefault;
          });

          if (_targetTemplate) {
            templateLocaleStr = _targetTemplate.content;
          }

          break;
        }
    }

    return templateLocaleStr;
  }
  /**
   * 判断是否是 debug mode
   * @private
   */
  ;

  _proto.isDebug = function isDebug() {
    return !isServer() && window.location.href.includes('cmstextid=1') || this.options.isDebugMode;
  }
  /**
   * debug 模式下多语言前面显示 text_id
   * @param textId 多语言 text_id
   * @param localeStr 多语言内容
   */
  ;

  _proto.generateDebugStr = function generateDebugStr(textId, localeStr) {
    var finalStr = localeStr;

    if (this.isDebug()) {
      finalStr = textId + ": " + localeStr;
    }

    return finalStr;
  }
  /**
   * 获取原始多语言
   * @param key 多语言 key
   * @param templateCategory 多模版用来命中模版的 category
   */
  ;

  _proto.getTargetLocaleStr = function getTargetLocaleStr(key, templateCategory) {
    var textId = I18n.getTextId(key);
    var _this$options = this.options,
        messages = _this$options.messages,
        locale = _this$options.locale;
    var targetLocaleMessages = messages[locale];
    var targetLocaleStr = textId;

    if (targetLocaleMessages) {
      var localeStrObj = targetLocaleMessages[textId];

      if (localeStrObj) {
        if (typeof localeStrObj === 'string') {
          targetLocaleStr = this.generateDebugStr(textId, localeStrObj);
        } else {
          targetLocaleStr = this.generateDebugStr(textId, this.getTemplateLocaleStr(localeStrObj, templateCategory));
        }
      }
    }

    return targetLocaleStr;
  }
  /**
   * 插值
   * @param content 多语言
   * @param args 替换多语言中变量的插值
   */
  ;

  _proto.interpolate = function interpolate(content) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var regexpStr = this.options.interpolation.prefix + "(\\w+)" + this.options.interpolation.postfix;
    var regexp = new RegExp(regexpStr, 'g');

    if (args.length === 1 && (isObject(args[0]) || isArray(args[0]))) {
      // @ts-ignore
      args = args[0];
    }

    return content.replace(regexp, function (match, p) {
      var v = args[p];
      return v === undefined ? match : v;
    });
  };

  _proto.clearTCache = function clearTCache() {
    this.tCache = {};
  }
  /**
   * 翻译函数
   * 正常参数应该是 key: string, interpolationObj?: Obj, templateCategory?: templateCategory
   * 需要兼容旧的使用方式 key: string, var1, var2...
   * @param key 多语言 key
   * @param args 插值以及多模版用来命中模版的 category
   */
  ;

  _proto.translate = function translate(key) {
    if (!key) {
      return '';
    }

    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    if (isObject(args[0]) || isArray(args[0])) {
      var interpolationObj = args[0];
      var targetLocaleStr = this.getTargetLocaleStr(key, args[1] === undefined ? '' : args[1]);
      var linkTransformedStr = this.transformLinkKeyWord(targetLocaleStr, interpolationObj);
      return this.interpolate(linkTransformedStr, interpolationObj);
    } else {
      if (args.length === 0) {
        var cacheKey = this.locale + ":" + key;

        if (this.tCache[cacheKey] && !this.isDebug()) {
          return this.tCache[cacheKey];
        }

        var _targetLocaleStr2 = this.getTargetLocaleStr(key, '');

        if (!this.isDebug()) {
          this.tCache[cacheKey] = _targetLocaleStr2;
        }

        return _targetLocaleStr2;
      }

      var _targetLocaleStr = this.getTargetLocaleStr(key, '');

      return this.interpolate.apply(this, [_targetLocaleStr].concat(args));
    }
  };

  _proto.t = function t(key) {
    for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      args[_key3 - 1] = arguments[_key3];
    }

    return this.translate.apply(this, [key].concat(args));
  }
  /**
   * @see vue-i18n mergeLocaleMessage
   */
  ;

  _proto.mergeLocaleMessage = function mergeLocaleMessage(locale, message) {
    // if (this._warnHtmlInMessage === 'warn' || this._warnHtmlInMessage === 'error') {
    //     this._checkLocaleMessage(locale, this._warnHtmlInMessage, message)
    // }
    // this._vm.$set(this._vm.messages, locale, merge({}, this._vm.messages[locale] || {}, message))
    this.options.messages[locale] = Object.assign({}, this.options.messages[locale] || {}, message);
  } // @ts-ignore
  ;

  _createClass(I18n, [{
    key: "locale",
    get: function get() {
      return this.options.locale;
    }
  }]);

  return I18n;
}();

export default I18n;
//# sourceMappingURL=i18n.esm.js.map
